function i(e) {
  return e == null || typeof e != "object" && typeof e != "function";
}
function f(e) {
  return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function a(e) {
  if (i(e))
    return e;
  if (Array.isArray(e) || f(e) || e instanceof ArrayBuffer || typeof SharedArrayBuffer < "u" && e instanceof SharedArrayBuffer)
    return e.slice(0);
  const r = Object.getPrototypeOf(e), t = r.constructor;
  if (e instanceof Date || e instanceof Map || e instanceof Set)
    return new t(e);
  if (e instanceof RegExp) {
    const n = new t(e);
    return n.lastIndex = e.lastIndex, n;
  }
  if (e instanceof DataView)
    return new t(e.buffer.slice(0));
  if (e instanceof Error) {
    const n = new t(e.message);
    return n.stack = e.stack, n.name = e.name, n.cause = e.cause, n;
  }
  if (typeof File < "u" && e instanceof File)
    return new t([e], e.name, { type: e.type, lastModified: e.lastModified });
  if (typeof e == "object") {
    const n = Object.create(r);
    return Object.assign(n, e);
  }
  return e;
}
export {
  a as c
};
